// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BigItem_wrapper__1Jh7l","image":"BigItem_image__1SS1R","content-container":"BigItem_content-container__2dwpr"};